import { render } from "./Shield.vue?vue&type=template&id=b8dffad8"
import script from "./Shield.vue?vue&type=script&lang=js"
export * from "./Shield.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__